import React from 'react'
import { Row } from 'react-bootstrap'
import { observer } from 'mobx-react'
import './styles.scss'
import { enablePdpRedesign } from 'src/utils'
@observer
class ProductTitle extends React.Component {
  render() {
    const titleClass = enablePdpRedesign()
      ? 'product-name-pdp mb-1'
      : 'product-name heading-1'
    const { name, secondaryTitle, isShowSecondaryTitle = true } = this.props

    return (
      <Row noGutters className="flex-column" tabIndex={0}>
        <span>
          <h1
            className={`${titleClass}  ${secondaryTitle ? 'mb-0' : ''}`}
            data-testid="qa-product-name">
            {name}
          </h1>
          {secondaryTitle && (
            <h2 className="secondary-title">{secondaryTitle}</h2>
          )}
        </span>
      </Row>
    )
  }
}

export { ProductTitle }
